import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";

const darkGraphite = "#212121";
const goldAccent = "#b89f50";

const LightshowList = () => {
  const files = [
    "soundWeb.html",
    "soundWebCrazy.html",
    "soundWebCrazyII.html",
    "soundWebCrazyIII.html",
    "soundWebCrazyIIIControlled.html",
    "soundWebCrazyIIIControlledGpt.html",
    "soundWebCrazyIIIControlledGptColorControlCode.html",
    "soundWebCrazyIIIControlledGptColorControlCodeMovement.html",
    "soundWebCrazyIIIControlledGptColorControlCodeMovementMoreOptions.html",
    "soundWebCrazyIIIControlledGptColorControlCodeMovementMoreOptionsCustom.html"
  ];

  return (
    <Box sx={{ textAlign: "center", mt: 10, mb: 10 }}>
      <Typography
        variant="h4"
        gutterBottom
        fontWeight="light"
        color={darkGraphite}
        textTransform="uppercase"
      >
        🎧 Experimentos de Audio Lightshow
      </Typography>

      <Typography
        variant="h6"
        gutterBottom
        fontWeight="bold"
        color={goldAccent}
        mb={6}
      >
        Visualizadores disponibles en /public/lightshow/
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {files.map((file, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Button
              fullWidth
              variant="contained"
              href={`/lightshow/${file}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                background: goldAccent,
                color: darkGraphite,
                fontWeight: 600,
                borderRadius: 1,
                py: 2,
                "&:hover": {
                  background: darkGraphite,
                  color: goldAccent,
                  transform: "translateY(-2px)",
                },
              }}
            >
              {file.replace(".html", "")}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LightshowList;
